import { lumiarToastError } from '@legacy/common/_components/LumiarToast'

import firebase from 'firebase/app'
import axios from 'axios'
import i18n from '../../../i18n'
import { googleSignin, googleSigninErrorKey } from 'services/googleSignin'

import 'firebase/analytics'
import 'firebase/auth'

const userExists = async email => {
  const response = await axios.get(`/api/users/find?email=${email}`)
  return response.data.status === 'found'
}

const firebaseSignOut = () => {
  firebase
    .auth()
    .signOut()
    .then(() => {})
    .catch(_error => {})
}

// Opens the backend session for the Google user. A refusal (AR-933: password
// account without Google login, unknown e-mail, expired token) is shown to the
// user and the Firebase session is dropped, so the next click opens the
// account picker again instead of silently bouncing back to the login page.
const internalLogin = async () => {
  const result = await googleSignin(window.firebaseUser)
  if (!result.success) {
    firebaseSignOut()
    lumiarToastError(i18n.t(googleSigninErrorKey(result.reason)))
    return false
  }
  window.location.href = '/'
  return true
}

const updateUserRegistrationStep = async (userId, skipUpdateUserRegistrationStep = false) => {
  if (skipUpdateUserRegistrationStep) {
    return
  }
  axios.get(`/api/users/update_step?email=${userId}&step=1`)
}

const deleteFirebaseUser = user => {
  user
    .delete()
    .then(() => {})
    .catch(_error => {})
}

const firebaseGoogleSignUp = async (
  event = undefined,
  skipUpdateUserRegistrationStep = false,
  callback = user => {},
) => {
  const provider = new firebase.auth.GoogleAuthProvider()
  firebase
    .auth()
    .signInWithPopup(provider)
    .then(async result => {
      const { user } = result
      if (await userExists(user.email)) {
        await updateUserRegistrationStep(user.email, skipUpdateUserRegistrationStep)
        if (await internalLogin()) {
          callback(user)
        }
      } else {
        deleteFirebaseUser(user)
        lumiarToastError(i18n.t('swal_error_user_does_not_exist_on_platform'))
      }
    })
    .catch(error => {
      lumiarToastError(error)
    })
}

export const associateWithGoogleAccount = ({ skipUpdateUserRegistrationStep = false, callback = user => {} }) => {
  firebaseGoogleSignUp('create', skipUpdateUserRegistrationStep, callback)
}

const initFirebaseAuth = () => {
  firebase.auth().onAuthStateChanged(user => {
    window.firebaseUser = user
  })
}

export const initFirebaseApp = () => {
  const firebaseConfig = {
    apiKey: 'AIzaSyDmARs3bs4pATx-8PZuoFQ35PA4zzFlx-A',
    authDomain: 'plataforma-educacional-lumiar.firebaseapp.com',
    projectId: 'plataforma-educacional-lumiar',
    storageBucket: 'plataforma-educacional-lumiar.appspot.com',
    messagingSenderId: '694989785408',
    appId: '1:694989785408:web:340e5d29de13f83e6492a5',
    measurementId: 'G-RZ51JH4ZS6',
  }
  if (firebase.apps.length <= 0) {
    firebase.initializeApp(firebaseConfig)
  }
  firebase.analytics()
  initFirebaseAuth()
}
